import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Package } from 'lucide-react';
import { useStore } from '../stores/appStore';

export const DeliveryCarousel: React.FC = () => {
  const { entregas } = useStore();
  const entregasAtivas = entregas.filter(e => e.ativa).sort((a, b) => a.ordem - b.ordem);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (entregasAtivas.length === 0) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % entregasAtivas.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [entregasAtivas.length]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % entregasAtivas.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + entregasAtivas.length) % entregasAtivas.length);
  };

  if (entregasAtivas.length === 0) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container-custom text-center">
          <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-2xl font-semibold text-gray-600 mb-2">
            Em breve fotos de entregas
          </h2>
          <p className="text-gray-500">
            Estamos preparando as fotos das primeiras entregas realizadas.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Entregas Realizadas
          </h2>
          <p className="text-lg text-gray-600">
            Veja a satisfação de nossos clientes com suas novas motos
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="relative h-96 rounded-xl overflow-hidden">
            {entregasAtivas.map((entrega, index) => (
              <div
                key={entrega.id}
                className={`absolute inset-0 transition-opacity duration-500 ${
                  index === currentIndex ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <img
                  src={entrega.imagem}
                  alt={entrega.titulo}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent">
                  <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                    <h3 className="text-2xl font-bold mb-2">{entrega.titulo}</h3>
                    <p className="text-lg opacity-90">{entrega.descricao}</p>
                    <p className="text-sm opacity-75 mt-2">
                      {new Date(entrega.data).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {entregasAtivas.length > 1 && (
            <>
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 p-3 rounded-full shadow-lg transition-all"
              >
                <ChevronLeft size={24} className="text-gray-800" />
              </button>
              
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 p-3 rounded-full shadow-lg transition-all"
              >
                <ChevronRight size={24} className="text-gray-800" />
              </button>
            </>
          )}

          {entregasAtivas.length > 1 && (
            <div className="flex justify-center mt-6 space-x-2">
              {entregasAtivas.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    index === currentIndex
                      ? 'bg-primary-600 w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          )}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-white rounded-xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Garanta sua moto hoje mesmo!
            </h3>
            <p className="text-gray-600 mb-6">
              Entregamos em todo o estado com rapidez e segurança.
            </p>
            <a
              href="https://wa.me/5513996763208"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-lg px-8 py-4"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};